import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSize = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M3 5V19C3 20.1 3.89 21 5 21H11V3H5C3.89 3 3 3.9 3 5ZM19 3H13V11H21V5C21 3.9 20.1 3 19 3ZM13 21H19C20.1 21 21 20.1 21 19V13H13V21Z" }) })
});
export default SvgSize;
